import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getItem, setItem } from '../../utils/helpers/storage-crud';
import ErrorHandler from '../error-handler/index';
import Header from './Header';
import Footer from './Footer';
import { parseLocationSearchParams } from '../../utils/helpers/parse-location-search-params';
import { Container } from '@mui/material';
export default function withLayout(
    WrappedComponent,
    header = true,
    footer = true, options
) {
    const Layout = (props) => {
        const [isWebView, setIsWebView] = useState(getItem('isWebView'));
        const params = parseLocationSearchParams(window.location.search);
        const isWebViewFromParams = params.utm_source === 'more_tab_app' || params.view_source === 'app';
        useEffect(() => {
            if (getItem('isWebView')) {
                setIsWebView(true);
            } else {
                if (isWebViewFromParams) {
                    setItem(true, 'isWebView');
                    setIsWebView(true);
                }
            }
        }, [props.isWebview]);

        const hideLayout = isWebView || isWebViewFromParams;
        return <Fragment>
            <Container maxWidth="sm">
                <ErrorHandler>
                    {(header && !hideLayout) && <Header options={options} />}
                </ErrorHandler>
                <div className="mb-6" />
                <ErrorHandler>
                    <WrappedComponent {...props} />
                </ErrorHandler>
                <ErrorHandler>
                    {(footer && !hideLayout) && <><div className="mt-20 h-4" /><Footer {...props} /></>}
                </ErrorHandler>
            </Container>
        </Fragment>;
    };

    Layout.propTypes = {
        isWebview: PropTypes.bool
    };

    return Layout;
}
